import {ContentCommentLikeDomain} from "../../domain/content/ContentCommentLikeDomain"
import {ContentCommentId} from "../../id/content/ContentCommentId"
import {ContentCommentLikeId} from "../../id/content/ContentCommentLikeId"
import {UserId} from "../../id/user/UserId"
import {ValueObject} from "ts-protocol-extension"

/**
 * 댓글 좋아요
 */
export class ContentCommentLikeValueObject implements ValueObject, ContentCommentLikeDomain {
    /**
     * 기본키
     */
    id: ContentCommentLikeId
    /**
     * 댓글 ID
     */
    contentCommentId: ContentCommentId
    /**
     * 사용자 ID
     */
    userId: UserId
    /**
     * 생성일
     */
    createdAt: Date

    constructor(o: Record<keyof ContentCommentLikeDomain, any>) {
        this.id = BigInt(o.id)
        this.contentCommentId = BigInt(o.contentCommentId)
        this.userId = BigInt(o.userId)
        this.createdAt = new Date(o.createdAt)
    }
}
